import { URI_REPORT } from '@/config/config'

export default async ({ rootState }, { query }) => {
  const opts = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'user-token': rootState['DATA-ACCESS'].userToken
    },
    body: JSON.stringify(query)
  }

  const userLoginInfoResult = await fetch(`${URI_REPORT}credits/credits`, opts)
  const jsonResult = await userLoginInfoResult.json()
  if (jsonResult.errors) {
    return Promise.reject(jsonResult.errors)
  }
  
  return jsonResult
}